module.exports = __webpack_public_path__ + "static/img/dia-del-nino-2.c85aeec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/dia-del-nino-2.jpg
// module id = NgWF
// module chunks = 1